import {Alert, AlertIcon, Button, ButtonGroup, Slide,} from "@chakra-ui/react";
import {useAlertBg, useSuccessBg, useTextColor} from "../../utils/colors";
import {Locale} from "../../utils/Language";

function BaseAlert({isOpen, children}) {
    const alertBg = useAlertBg()
    const mainText = useTextColor();

    return <Slide direction="bottom" in={isOpen} style={{ zIndex: 10 }}>
        <Alert
            w={{
                base: "calc(100vw - 6%)",
                md: "calc(100vw - 8%)",
                lg: "calc(100vw - 6%)",
                xl: "calc(100vw - 350px)",
                "2xl": "calc(100vw - 365px)",
            }}
            mx="auto"
            rounded="2xl"
            status="warning"
            backdropFilter="blur(10px)"
            bg={alertBg}
            textColor={mainText}
            mb="10"
            flexDirection={{base: "column", "2sm": "row"}}
        >
            <AlertIcon />
            {children}
        </Alert>
    </Slide>
}

export function SaveAlert({saving, visible, onSave, onDiscard}) {

    const brand = useSuccessBg()

    return (
        <BaseAlert isOpen={visible}>
            您有一些未保存的更改

            <ButtonGroup ml={{
                base: "0",
                md: "auto"
            }}>
                <Button bg={brand} isLoading={saving} onClick={onSave}>
                    保存
                </Button>
                <Button onClick={onDiscard}>
                    放弃更改
                </Button>
            </ButtonGroup>
        </BaseAlert>
    );
}

export function SubmitAlert({loading, visible, onSubmit}) {

    const brand = useSuccessBg()

    return (
      <BaseAlert isOpen={visible}>
          您现在可以创建此项目了

          <Button ml={{"2sm": "auto"}} bg={brand} isLoading={loading} onClick={onSubmit}>
              创建项目
          </Button>
      </BaseAlert>
  )
}